import React from "react"

export const VoterIconBackground: React.FC = () => (
    <div className="graphAnimation" aria-hidden="true">
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.7605 1.37915C21.9321 0.207578 23.8321 0.207578 25.0037 1.37915L27.7351 4.1106L31.5544 3.08813C33.1546 2.65943 34.7992 3.60918 35.2283 5.20923L36.241 8.99146L40.2898 10.0764C41.89 10.5053 42.8395 12.15 42.4109 13.7502L41.3464 17.7219L44.3855 20.761C45.5571 21.9326 45.5571 23.8326 44.3855 25.0042L41.3464 28.0422L42.4109 32.0139C42.8397 33.6143 41.8901 35.2598 40.2898 35.6887L36.241 36.7727L35.2283 40.5549C34.7994 42.1553 33.1548 43.1049 31.5544 42.676L27.7361 41.6526L25.0037 44.386C23.8321 45.5576 21.9321 45.5576 20.7605 44.386L18.0271 41.6526L14.2097 42.676C12.6093 43.1049 10.9637 42.1553 10.5349 40.5549L9.52124 36.7727L5.47437 35.6887C3.87397 35.2599 2.92445 33.6143 3.35327 32.0139L4.41675 28.0422L1.37866 25.0042C0.207089 23.8326 0.207089 21.9326 1.37866 20.761L4.41675 17.7209L3.35327 13.7502C2.92471 12.15 3.8741 10.5052 5.47437 10.0764L9.52026 8.99146L10.5349 5.20923C10.9638 3.60896 12.6094 2.65933 14.2097 3.08813L18.0281 4.1106L20.7605 1.37915Z"
                fill="currentColor"
            />
        </svg>
    </div>
)

export const CandidatesIconBackground: React.FC = () => (
    <div className="graphAnimation" aria-hidden="true">
        <svg width="61" height="62" viewBox="0 0 61 62" xmlns="http://www.w3.org/2000/svg">
            <rect x="-1" y="31" width="45" height="45" rx="4" transform="rotate(-45 -1 31)" fill="currentColor" />
        </svg>
    </div>
)

export const CalendarIconBackground: React.FC = () => (
    <div className="graphAnimation" aria-hidden="true">
        <svg width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="32.7502"
                y="32.5"
                width="32.25"
                height="32.25"
                rx="3"
                transform="rotate(-180 32.7502 32.5)"
                fill="currentColor"
            />
        </svg>
        <svg width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="32.7502"
                y="32.5"
                width="32.25"
                height="32.25"
                rx="3"
                transform="rotate(-180 32.7502 32.5)"
                fill="currentColor"
            />
        </svg>
    </div>
)
